import React from 'react';
export function DemoBadge({
  className = ''
}: {
  className?: string;
}) {
  return <span title="Contenido de demostración, no forma parte de la obra de Nicole" className={`inline-flex items-center rounded-sm border border-white/30 bg-night/70 px-1.5 py-0.5 font-sans text-[10px] font-semibold uppercase tracking-[0.12em] text-white ${className}`} data-id="element-131" data-mp="2g5oesutkkoua">
      Demo
    </span>;
}